import {
  GET_ADMINS_FAIL,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  GET_ADMINS_SUCCESS,
  POST_ADD_ADMIN_FAIL,
  POST_ADD_ADMIN_SUCCESS,
  CREATE_MANAGER_SUCCESS,
  CREATE_MANAGER_FAIL,
  GET_WORKSPACE_DETAILS_SUCCESS,
  GET_WORKSPACE_DETAILS_FAIL,
  UPDATE_WORKSPACE_DETAILS_SUCCESS,
  UPDATE_WORKSPACE_DETAILS_FAIL,
  UPDATE_WORKSPACE_USER_SUCCESS,
  UPDATE_WORKSPACE_USER_FAIL,
  DELETE_WORKSPACE_USER_SUCCESS,
  DELETE_WORKSPACE_USER_FAIL,
  TOGGLE_ACCOUNT_STATUS_SUCCESS,
  TOGGLE_ACCOUNT_STATUS_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  error: [],
  adminList: [],
  succRes: [],
  loading: false,
  details: [],
};

const Participant = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETE_WORKSPACE_USER_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case DELETE_WORKSPACE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TOGGLE_ACCOUNT_STATUS_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case TOGGLE_ACCOUNT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_WORKSPACE_USER_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case UPDATE_WORKSPACE_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_WORKSPACE_DETAILS_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case UPDATE_WORKSPACE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_WORKSPACE_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload,
        loading: false,
      };

    case GET_WORKSPACE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_MANAGER_SUCCESS:
      return {
        ...state,
        loading: false,
        succRes: action.payload,
      };

    case CREATE_MANAGER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ADMINS_SUCCESS:
      return {
        ...state,
        adminList: action.payload,
        loading: false,
      };

    case GET_ADMINS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case POST_ADD_ADMIN_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case POST_ADD_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        loading: false,
      };

    case DELETE_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return {
        ...state,
        loading: true,
        error: [],
      };
  }
};

export default Participant;
